(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-external/assets/javascripts/route-play-external.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-external/assets/javascripts/route-play-external.js');
"use strict";

const {
  PlayExternalPrompt
} = svs.components.tipsen.RoutePlayExternal;
const {
  Article
} = svs.components.tipsen.articleComponents;
const {
  trackEvent
} = svs.components.analytics;
const RoutePlayExternal = () => {
  var _svs;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const articleId = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.tipsen) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.externalSystemsConfig) === null || _svs === void 0 || (_svs = _svs.externalSystems) === null || _svs === void 0 ? void 0 : _svs.article;
  if (svs.tipsen.data.externalSystemsUploadError) {
    const eventData = {
      category: 'Andelsspel - upload file',
      action: 'upload failure',
      opt_label: svs.tipsen.data.externalSystemsUploadError.message
    };
    trackEvent(eventData);
  }
  return React.createElement("div", {
    className: "game-menu-containers external-systems"
  }, React.createElement(PlayExternalPrompt, {
    isLoggedIn: isLoggedIn
  }), articleId && React.createElement(Article, {
    articleId: articleId,
    className: "external-article elevation-100 paper paper-sport",
    noArticleMessage: "F\xF6r tillf\xE4llet har vi ingen externa systemspel artikel"
  }));
};
setGlobal('svs.components.tipsen.RoutePlayExternal', {
  RoutePlayExternal
});

 })(window);